import { createRouter, createWebHashHistory } from 'vue-router'
import warninglogin from '../views/warning/warninglogin.vue'   //登录页
import warningList from '../views/warning/list.vue'      //预警列表
import warningForget from '../views/warning/forget.vue'      //修改密码
import warningAdd from '../views/warning/add.vue'   //预警设置
// import edit from '../views/warning/edit.vue'   //修改预警信息
import warningEdit from '../views/warning/edit.vue'   //修改预警信息
import warningChangePwd from '../views/warning/changePwd.vue'   //修改预警信息
import homepage from '../views/homepage.vue'
import indexTool from '../views/indexTool/index'
import indexGroupTool from '../views/indexTool/indexGroup'
import indexLogin from '../views/indexTool/login'
import indexList from '../views/indexTool/list'
import indexForget from '../views/indexTool/forget'
import indexChangePwd from '../views/indexTool/changePwd'
import indexNoData from '../views/indexTool/noData'
import indexDataList from '../views/indexTool/dataList'
import hotLogin from '../views/hotWord/login'
import hotDataList from '../views/hotWord/dataList'
import hotWord from '../views/hotWord/index'
import searchResult from '../views/hotWord/searchResult'
import addHotDataList from '../views/hotWord/addDataList'
import editHotDataList from '../views/hotWord/editDataList'
import hotChangePwd from '../views/hotWord/changePwd.vue'
import hotForget from '../views/hotWord/forget'
const routes = [
  // {
  //   path: '/',       //登录页
  //   name: '',
  //   meta:{
  //     title:'尼尔森IQ社会化媒体研究'
  //   },
  //   component: homepage
  // },
// {
//   path: '/',       //登录页
//   name: '',
//   meta:{
//     title:'NSI社媒热点'
//   },
//   component: hotLogin
// },
{
  path: '/',       //登录页
  name: '',
  meta:{
    title:'NSI社媒指数'
  },
  component: indexLogin
},
// {
//     path: '/',       //登录页
//     name: '',
//     meta:{
//       title:'NSI舆情预警'
//     },
//     component: warninglogin
// },
    {
        path: '/homepage',       //首页
        name: 'homepage',
        meta:{
          title:'尼尔森IQ社会化媒体研究'
        },
        component: homepage
    },

    {
      path: '/editHotDataList',       //首页
      name: 'editHotDataList',
      meta:{
        title:'NSI社媒热点'
      },
      component:  editHotDataList
  },
  {
    path: '/hotChangePwd',       //首页
    name: 'hotChangePwd',
    meta:{
      title:'NSI社媒热点'
    },
    component:  hotChangePwd
},
{
  path: '/hotForget',       //首页
  name: 'hotForget',
  meta:{
    title:'NSI社媒热点'
  },
  component: hotForget
},
  {
    path: '/addHotDataList',       //首页
    name: 'addHotDataList',
    meta:{
      title:'NSI社媒热点'
    },
    component:  addHotDataList
},
  {
    path: '/indexDataList',       //首页
    name: 'indexDataList',
    meta:{
      title:'NSI社媒指数'
    },
    component:  indexDataList
},
  {
    path: '/hotDataList',       //首页
    name: 'hotDataList',
    meta:{
      title:'NSI社媒热点'
    },
    component:  hotDataList
},
  {
    path: '/hotLogin',       //首页
    name: 'hotLogin',
    meta:{
      title:'NSI社媒热点'
    },
    component:  hotLogin
},
    {
      path: '/indexLogin',       //首页
      name: 'indexLogin',
      component: indexLogin,
      meta:{
        title:'NSI社媒指数'
      },
    },
    {
      path: '/indexChangePwd',       //首页
      name: 'indexChangePwd',
      component: indexChangePwd,
      meta:{
        title:'NSI社媒指数'
      },
    },
    {
      path: '/indexNoData',       //首页
      name: 'indexNoData',
      component: indexNoData,
      meta:{
        title:'NSI社媒指数'
      },
    },
    {
      path: '/indexList',       //首页
      name: 'indexList',
      component: indexList,
      meta:{
        title:'NSI社媒指数'
      },
    },
    {
      path: '/indexForget',       //首页
      name: 'indexForget',
      component: indexForget,
      meta:{
        title:'NSI社媒指数'
      },
    },
    {
      path: '/indexTool',       //首页
      name: 'indexTool',
      component: indexTool,
      meta:{
        title:'NSI社媒指数'
      },
    },
    {
      path: '/indexGroupTool',       //首页
      name: 'indexGroupTool',
      component: indexGroupTool,
      meta:{
        title:'NSI社媒指数'
      },
    },
  {
    path: '/warninglogin',      //预警列表
    name: 'warninglogin',
    meta:{
      title:'NSI舆情预警'
    },
    component: warninglogin
  }, {
    path: '/warningList',      //预警列表
    name: 'warningList',
    meta:{
      title:'NSI舆情预警'
    },
    component: warningList
  },{
    name:'warningForget',
    path:'/warningForget',      //修改密码
    meta:{
      title:'NSI舆情预警'
    },
    component:warningForget
  },{
    path:'/warningAdd',     //预警设置
    name:'warningAdd',
    meta:{
      title:'NSI舆情预警'
    },
    component:warningAdd
  },{
    path:'/warningEdit',     //修改预警信息
    name:'warningEdit',
    meta:{
      title:'NSI舆情预警'
    },
    component:warningEdit
  },{
    path:'/warningChangePwd',     //修改预警信息
    name:'warningChangePwd',
    meta:{
      title:'NSI舆情预警'
    },
    component:warningChangePwd
  },
  {
    path:'/hotWord',
    component:hotWord,
    meta:{
      title:'NSI社媒热点'
    },
  }
  ,
  {
    path:'/searchResult',
    component:searchResult,
    meta:{
      title:'NSI社媒热点'
    },
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

const whiteList = [
  '/hotLogin',
  '/hotForget',
  '/indexLogin',
  '/indexForget'
]

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '尼尔森IQ社会化媒体研究'
  // if(to.name=='indexTool'){
  //   document.title = 'NSI社媒指数'
  // }else if(to.name=='homepage'){
  //   document.title = '尼尔森IQ社会化媒体研究'
  // }else{
  //   document.title = 'NSI舆情预警'
  // }
  const token =  localStorage.getItem('token')
  if (token){
    if (to.path === '/hotLogin') {
      next({ path: '/hotWord' })
    }else if (to.path === '/indexLogin') {
      next({ path: '/indexTool' })
    } else {
      next()
    }
  }else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else if (to.path === '/hotWord') {
      next({ path: '/hotLogin' })
    }else if (to.path === '/indexTool') {
      next({ path: '/indexLogin' })
    }else if (to.path === '/') {
      next()
    }
  }
  console.log("=========>",to.path)
})

export default router
